import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const MailSentLiner24 = _ref => {
  let {
    size = 24
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2 8.5C2 4 3 3.5 7 3.5H17C21 3.5 22 4 22 8.5V15.5C22 20 21 20.5 17 20.5H7M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9M2 16.5H8M2 12.5H5",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};